import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type DateChangePayload = {
  date_prior: number;
  date_after: number;
};

export type DateChangeEvent = {
  datePrior: number;
  dateAfter: number;
  deltaDays: number;
};

const dateChangeSchema = z.object({
  date_prior: z.number(),
  date_after: z.number(),
});

export const LID_DATE_CHANGED = {
  value: 0x0e,
  name: "Date Change Event",
  format: "ii........",
  fields: ["date_prior", "date_after"],
  postprocess: rec => ({
    datePrior: rec.date_prior,
    dateAfter: rec.date_after,
    deltaDays: rec.date_after - rec.date_prior,
  }),
  schema: dateChangeSchema,
} as const satisfies TandemEventDefinition<DateChangePayload, DateChangeEvent>;
